import { authHeaders, fetchWithAuthRetry, getApiUrl, parseApiError } from './common';

export type NavigationBadges = {
  plans: number | null;
  runners: number | null;
  coActions: number | null;
  completionReports: number | null;
  codeReviews: number | null;
  postMortems: number | null;
};

export const fetchNavigationBadges = async (token: string, projectId: string): Promise<NavigationBadges> => {
  const response = await fetchWithAuthRetry(
    `${getApiUrl()}/api/projects/${encodeURIComponent(projectId)}/navigation-badges`,
    { cache: 'no-store', headers: authHeaders(token) },
  );
  if (!response.ok) {
    throw await parseApiError(response, `Failed to fetch navigation badges: ${response.status}`);
  }
  const payload = (await response.json()) as { data: NavigationBadges };
  return payload.data;
};
